module.exports = __webpack_public_path__ + "static/media/ВКС_График_проведения_регионального_этапа_21_09_2023.pdf";